import React from 'react';
import styles from '../../../styles/automation/results/resultsPanel.module.scss';

function formatPlaywrightError(rawError) {
    if (!rawError) return 'Assertion failed';
  
    // Strip ANSI color codes
    const cleanError = rawError.replace(/\u001b\[[0-9;]*m/g, '');
  
    // Parse the error into structured format
    const lines = cleanError.split('\n').filter(line => line.trim());
  
    const errorInfo = {
      assertion: '',
      locator: '',
      expected: '',
      received: '',
      timeout: '',
      elementDetails: '',
      callLog: []
    };
  
    // Extract key information
    lines.forEach(line => {
      if (line.includes('expect(') && line.includes(').')) {
        // Extract the assertion
        const match = line.match(/expect\((.*?)\)\.(.*?)(?:\((.*?)\))?/);
        if (match) {
          errorInfo.assertion = `expect(${match[1]}).${match[2]}${match[3] ? `(${match[3]})` : ''}`;
        }
      } else if (line.includes('Locator:')) {
        errorInfo.locator = line.replace('Locator:', '').trim();
      } else if (line.includes('Expected')) {
        errorInfo.expected = line.replace(/Expected.*?:/, '').trim();
      } else if (line.includes('Received')) {
        errorInfo.received = line.replace(/Received.*?:/, '').trim();
      } else if (line.match(/timeout:\s*/i)) {
        errorInfo.timeout = line.replace(/timeout:\s*/i, '').trim();
      } else if (line.match(/^timeout:\s*/i)) {
        errorInfo.timeout = line.replace(/^timeout:\s*/i, '').trim();
      } else if (line.includes('locator resolved to')) {
        // Extract element info
        const elementMatch = line.match(/<([^>]+)>/);
        if (elementMatch) {
          errorInfo.elementDetails = elementMatch[0];
        }
      } else if (line.includes('waiting for') || line.includes('unexpected value')) {
        errorInfo.callLog.push(line.trim());
      }
      else {
        errorInfo.callLog.push(line.trim());
      }
    });
  
    return errorInfo;
}

export default function ErrorDetailsDisplay({ errorInfo }) {
    if (!errorInfo) return null;
    
    const formattedError = typeof errorInfo === 'string' 
      ? formatPlaywrightError(errorInfo) 
      : errorInfo;
    
    return (
        <div className={styles.errorDetailsContainer}>
            {formattedError.assertion && (
                <div className={styles.errorDetailRow}>
                    <span className={styles.errorLabel}>Assertion:</span>
                    <code className={styles.errorValue}>{formattedError.assertion}</code>
                </div>
            )}
            {formattedError.locator && (
                <div className={styles.errorDetailRow}>
                    <span className={styles.errorLabel}>Locator:</span>
                    <code className={styles.errorValue}>{formattedError.locator}</code>
                </div>
            )}
            {formattedError.expected && (
                <div className={styles.errorDetailRow}>
                    <span className={styles.errorLabel}>Expected:</span>
                    <code className={styles.errorValue}>{formattedError.expected}</code>
                </div>
            )}
            {formattedError.received && (
                <div className={styles.errorDetailRow}>
                    <span className={styles.errorLabel}>Received:</span>
                    <code className={styles.errorValue}>{formattedError.received}</code>
                </div>
            )}
            {formattedError.timeout && (
                <div className={styles.errorDetailRow}>
                    <span className={styles.errorLabel}>Timeout:</span>
                    <span className={styles.errorValue}>{formattedError.timeout}</span>
                </div>
            )}
            {formattedError.elementDetails && (
                <div className={styles.errorDetailRow}>
                    <span className={styles.errorLabel}>Element:</span>
                    <code className={styles.errorValue}>{formattedError.elementDetails}</code>
                </div>
            )}
            {formattedError.callLog && formattedError.callLog.length > 0 && (
                <div className={styles.errorDetailSection}>
                    <div className={styles.errorDetailRow}>
                        <span className={styles.errorLabel}>Details:</span>
                    </div>
                    <div className={styles.errorCallLog}>
                        {formattedError.callLog.map((log, index) => (
                            <div key={index} className={styles.errorCallLogItem}>
                                <span className={styles.errorBullet}>•</span>
                                <span className={styles.errorCallLogText}>{log}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}